import classNames from 'classnames'
import React from 'react'
import { Dropdown, Popover } from 'antd'
import './index.less'
import styles from './index.module.less'

export default ({ className = null, placement = 'bottomLeft', noBorder = null, children = null, ...otherProps }) => {
  return <Dropdown
    overlayClassName={classNames('mn-dropdown', { 'no-border': noBorder }, className)}
    placement={placement}
    {...otherProps}
  >
    {children}
  </Dropdown>
}

export const PopoverCard = ({ children, overlayClassName, ...otherProps }) => {
  return <Popover
    {...otherProps}
    overlayClassName={classNames(styles['mn-popover-card'], overlayClassName)}
  >
    {children}
  </Popover>
}
